import reduxConstants from "../../utils/redux/constant.js";

export default reduxConstants("liabilities", [
  "CLEAR_LIABILITIES",
  "SET_LIABILITIES",
  "SET_DEDUCTION_CARDS",
  "SET_FILTER",
  "SET_FILTER",
  "SET_SORT_BY",
  "SET_SORT_DIRECTION",
]);
